import { TableFilterConfig } from '@/components/data-table/filters-v2';
import i18n from '@/core/i18n';
import {
  DEFAULT_PAGE_SIZE_CLIENTS_SHORT_ENTITIES,
  DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES,
} from '@/lib/constants/pagination';
import { getShortClients } from '@/modules/clients/api/clients.api';
import { EntityAvatar } from '@/modules/common';
import { getShortProjects, ProjectBillingModel } from '@/modules/projects';
import { renderProjectFilterLabel } from '@/modules/projects/helpers/project-dropdown-option';

import {
  INVOICES_FILTER_KEY_BILLING_MODEL,
  INVOICES_FILTER_KEY_CLIENT,
  INVOICES_FILTER_KEY_PROJECT,
  INVOICES_FILTER_KEY_SEARCH,
} from './invoices-filter-keys';

export const SEARCH_FILTER_MIN_CHARACTERS = 2;

export const getGenerateInvoicesFiltersConfig = (): TableFilterConfig[] => [
  {
    type: 'search',
    name: INVOICES_FILTER_KEY_SEARCH,
    label: i18n.t('authenticated.invoices:new.filters.search.label'),
    placeholder: i18n.t('authenticated.invoices:new.filters.search.placeholder'),
    minCharacters: SEARCH_FILTER_MIN_CHARACTERS,
    saveable: false,
  },
  {
    type: 'dynamic-autocomplete',
    name: INVOICES_FILTER_KEY_CLIENT,
    label: i18n.t('authenticated.invoices:filters.client'),
    withSearch: true,
    loadOptions: params =>
      getShortClients({
        filter: { searchString: params.searchString },
        pagination: {
          cursor: params.cursor,
          pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE_CLIENTS_SHORT_ENTITIES,
        },
      }),
    renderLabel: (value, option) => (
      <div className="flex items-center gap-2">
        <EntityAvatar image={option.avatar} name={value} size="xs" shape="circle" />
        <span className="text-sm">{value}</span>
      </div>
    ),
    order: 1,
  },
  {
    type: 'autocomplete',
    name: INVOICES_FILTER_KEY_BILLING_MODEL,
    label: i18n.t('authenticated.invoices:new.filters.billingModel.label'),
    options: [
      {
        label: i18n.t('authenticated.invoices:new.filters.billingModel.options.timeMaterial'),
        value: ProjectBillingModel.TM,
      },
      {
        label: i18n.t('authenticated.invoices:new.filters.billingModel.options.fixedPrice'),
        value: ProjectBillingModel.FixedPrice,
      },
      {
        label: i18n.t('authenticated.invoices:new.filters.billingModel.options.nonBillable'),
        value: ProjectBillingModel.NonBillable,
      },
    ],
    order: 3,
  },
  {
    type: 'dynamic-autocomplete',
    name: INVOICES_FILTER_KEY_PROJECT,
    label: i18n.t('authenticated.invoices:filters.project'),
    withSearch: true,
    loadOptions: params =>
      getShortProjects({
        filter: { searchString: params.searchString },
        pagination: {
          cursor: params.cursor,
          pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES,
        },
      }),
    renderLabel: renderProjectFilterLabel,
    order: 2,
  },
];
